import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import { Button, Tooltip } from 'legion-ui';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`Tooltips displays informative text when users hover, focus, or click an element.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Tooltip } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h2>{`Variant`}</h2>
    <p>{`Legion-ui have three varian of tooltip`}</p>
    <h3><strong parentName="h3">{`Title`}</strong></h3>
    <p>{`You can change the Tooltip description with title prop`}</p>
    <div className="wrapper-display-component-three">
  <div className="wrapper-tooltip-items">
    <Tooltip title="This is a text tooltip" mdxType="Tooltip">
      <Button mdxType="Button">Do hover here</Button>
    </Tooltip>
  </div>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Tooltip title="This is a text tooltip">
  <Button>Do hover here</Button>
</Tooltip>
`}</code></pre>
    <h3><strong parentName="h3">{`Placement`}</strong></h3>
    <p>{`Change the placement of the tooltip with the placement prop`}</p>
    <div className="wrapper-display-component-three">
  <div className="wrapper-tooltip-items">
    <Tooltip title="This is a tooltip" placement="top" mdxType="Tooltip">
      <Button mdxType="Button">Top</Button>
    </Tooltip>
  </div>
      <div className="wrapper-tooltip-items">
  <Tooltip title="This is a tooltip" placement="bottom" mdxType="Tooltip">
    <Button mdxType="Button">Bottom</Button>
  </Tooltip>
      </div>
      <div className="wrapper-tooltip-items">
  <Tooltip title="This is a tooltip" placement="left" mdxType="Tooltip">
    <Button mdxType="Button">Left</Button>
  </Tooltip>
      </div>
  <div className="wrapper-tooltip-items">
    <Tooltip title="This is a tooltip" placement="right" mdxType="Tooltip">
      <Button mdxType="Button">Right</Button>
    </Tooltip>
  </div>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`  <Tooltip title="This is a tooltip" placement="top"><Button>Top</Button></Tooltip>
  <Tooltip title="This is a tooltip" placement="bottom"><Button>Bottom</Button></Tooltip>
  <Tooltip title="This is a tooltip" placement="left"><Button>Left</Button></Tooltip>
  <Tooltip title="This is a tooltip" placement="right"><Button>Right</Button></Tooltip>
`}</code></pre>
    <h3><strong parentName="h3">{`Not Arrow`}</strong></h3>
    <p>{`In some cases you may need to remove the arrow from the tooltip for this case you can use the arrow property`}</p>
    <div className="wrapper-display-component-three">
  <div className="wrapper-tooltip-items">
    <Tooltip title="tooltip not arrow" placement="top" arrow={false} mdxType="Tooltip">
      <Button mdxType="Button">Top</Button>
    </Tooltip>
  </div>
      <div className="wrapper-tooltip-items">
  <Tooltip title="tooltip not arrow" placement="bottom" arrow={false} mdxType="Tooltip">
    <Button mdxType="Button">Bottom</Button>
  </Tooltip>
      </div>
      <div className="wrapper-tooltip-items">
  <Tooltip title="tooltip not arrow" placement="left" arrow={false} mdxType="Tooltip">
    <Button mdxType="Button">Left</Button>
  </Tooltip>
      </div>
  <div className="wrapper-tooltip-items">
    <Tooltip title="tooltip not arrow" placement="right" arrow={false} mdxType="Tooltip">
      <Button mdxType="Button">Right</Button>
    </Tooltip>
  </div>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Tooltip title="tooltip not arrow" arrow={false} placement="top"><Button>Top</Button></Tooltip>
<Tooltip title="tooltip not arrow" arrow={false} placement="bottom"><Button>Bottom</Button></Tooltip>
<Tooltip title="tooltip not arrow" arrow={false} placement="left"><Button>Left</Button></Tooltip>
<Tooltip title="tooltip not arrow" arrow={false} placement="right"><Button>Right</Button></Tooltip>
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`title`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Text Tooltip`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`placement`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`top-start`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`top`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`top-end`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`left`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`bottom-start`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`bottom`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`bottom-end`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`right`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`top`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Tooltip placement relative to the target`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`arrow`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hide tooltip arrow icon`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      